import moment from 'moment'
import React, { useState } from 'react'
import { IconButton, Tooltip, Menu, MenuItem } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu';

import { StopModal } from './QuickLook'
import Formatter from '../../../utils/Formatter'
import PreviewSources from './PreviewSources'
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent'
import RecordActions from './recordActions'
import schema from '../../../routes/permissions/schema'

const GridEvent = (props) => {
  const {
    event,
    encoders,
    toggleFullscreen,
    timeZone,
    handleRecord,
    handleStop,
    handlePause,
    getStatusAsClassName,
  } = props
  const [showStopModal, setShowStopModal] = useState(false)
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)
  const [lastRequest, setLastRequest] = useState(0)
  const clientTimeZone = moment.tz(timeZone).format('z')
  const shortenedTitle =
    event.title.length > 72 ? event.title.substring(0, 73) + '...' : event.title

  const beginStopEvent = () => {
    setMenuAnchorEl(null)
    setShowStopModal(true)
  }

  const handleOpenMenu = event => {
    setMenuAnchorEl(event.currentTarget)
  }
  const handleCloseMenu = () => {
    setMenuAnchorEl(null)
  }
  const eventEncoder =
    event.assignedEncoder &&
    encoders.data.find(
      (encoder) => encoder.encoderID === event.assignedEncoder
    )
  const encoderOnline = eventEncoder && eventEncoder.online
  const status = event.eventStatus.toLowerCase()
  // request was within 2.5 seconds
  const requestDelayTime = 2500
  const recentRequest = lastRequest > new Date().getTime() - requestDelayTime
  const recOk = (status === 'available' || status === 'new') && encoderOnline
  const handleAction = (next) => {
    setLastRequest(new Date().getTime())
    setMenuAnchorEl(null)
    return next
  }
  
  return (
    <>
      <StopModal
        event={event}
        onHide={() => setShowStopModal(false)}
        show={showStopModal}
        onConfirm={() => {
          setShowStopModal(false)
          handleStop()
        }}
      />
      <div className='grid-event-container'>
        <div className='grid-event-status-container-container'>
          <Tooltip title={<h6>{props.event.eventStatus}</h6>}>
            <div
              className={
                'event-status-container ' +
                getStatusAsClassName(props.event.eventStatus)
              }
            />
          </Tooltip>
        </div>
        <div className='event-container'>
          <div>
            <PreviewSources
              event={event}
              encoders={encoders}
              autoSelect={true}
            />
          </div>
          <div className='event-info-container'>
            <Tooltip title={<h6>{event.title}</h6>}>
              <span className='event-info-heading'>{shortenedTitle}</span>
            </Tooltip>
            <div className='event-info-subheading'>
              <span>{`${
                Formatter.getHeadingDateFormat(event.startDateTime) +
                ' ' +
                clientTimeZone
              }`}</span>
              <span>{event.eventID}</span>
            </div>
          </div>
          <div className='event-action-menu-button'>
            <IconButton onClick={handleOpenMenu}>
              <MenuIcon />
            </IconButton>
          </div>
          <GridMenu
            menuAnchorEl={menuAnchorEl}
            handleCloseMenu={handleCloseMenu}
            toggleFullscreen={toggleFullscreen}
            recentRequest={recentRequest}
            recOk={recOk}
            handleAction={handleAction}
            handleRecord={handleRecord}
            beginStopEvent={beginStopEvent}
            status={status}
            handlePause={handlePause}
            event={event}
          />
        </div>
      </div>
    </>
  )
}

export default GridEvent
const GridMenu = props => {
  const { menuAnchorEl, handleCloseMenu, toggleFullscreen, recentRequest, recOk, handleAction, handleRecord, beginStopEvent, status, handlePause, event } = props
  return <Menu
    className='event-action-menu'
    anchorEl={menuAnchorEl}
    keepMounted
    open={menuAnchorEl !== null}
    onClose={handleCloseMenu}
  >
    <MenuItem onClick={() => toggleFullscreen()}>
      <i className='fa fa-pencil' /> Edit
    </MenuItem>
    <RestrictedComponent permissionCheck={schema.EVENT.RECORD_START}>
      <MenuItem
        className='record'
        disabled={recentRequest || !recOk}
        onClick={(e) => {
          handleAction(handleRecord)(e);
        } }
      >
        <i className='fa fa-circle' /> Start
      </MenuItem>
    </RestrictedComponent>
    <RestrictedComponent permissionCheck={schema.EVENT.RECORD_STOP}>
      <MenuItem
        className='stop'
        onClick={beginStopEvent}
        disabled={recentRequest || status !== 'live'}
      >
        <i className='fa fa-stop' /> Stop
      </MenuItem>
    </RestrictedComponent>
    <RestrictedComponent permissionCheck={schema.EVENT.RECORD_PAUSE}>
      <MenuItem
        className='pause resume'
        onClick={(e) => {
          handleAction(handlePause)(e);
        } }
        disabled={recentRequest || !(status === 'live' || status === 'on break')}
      >
        {event.eventStatus.toLowerCase() !== 'live' ? (
          <>
            <i className='fa fa-play' /> Resume
          </>
        ) : (
          <>
            <i className='fa fa-pause' /> Pause
          </>
        )}
      </MenuItem>
    </RestrictedComponent>
  </Menu>;
}

